import React from "react";
import BitHistoryTable from "./table/BitHistoryTable";
import { useMediaQuery } from "react-responsive";

function Bid() {
  const isTablet = useMediaQuery({ query: "(max-width: 790px)" });
  return (
    <div className="mt-2">
      <h3>Your Bid Details</h3>

      <BitHistoryTable />
    </div>
  );
}

export default Bid;
